import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';
import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SaveProject = () => {
    const { t } = useTranslation();
    const { hasActiveProject, isDirty, isSaving } = usePlacementStore(
        useShallow((state) => ({
            hasActiveProject: state.activeProject !== null,
            isDirty: state.isDirty,
            isSaving: state.isSaving
        }))
    );

    return (
        <Menu.Item
            disabled={!hasActiveProject || isSaving || !isDirty}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="save" />
            }
            rightSection={<span className="text-[13px] text-text-placeholder">{ShortcutAction.SaveProject}</span>}
            onClick={() => window.dispatchEvent(new Event(projectsMenuEvents.triggerSave))}
        >
            {t('labelSaveProject')}
        </Menu.Item>
    );
};
